import { Vue, BitrixVue } from 'ui.vue';
Vue.component('vue-product-price', {
    computed: {
        localize: function () {
            return BX?.Vue.getFilteredPhrases("");
        },
        catalogProduct: function () {
            return this.$store.getters['catalog/findItem'](this.$props.productId);
        },
        productCurrency: function () {
            return (this.catalogProduct && this.catalogProduct.CURRENCY) ? this.catalogProduct.CURRENCY : "";
        },
        productCode: function () {
            return this.catalogProduct ? (this.catalogProduct.PRODUCT_XML_ID || this.catalogProduct.XML_ID) : "";
        },
        // price
        productPrice: function () {
            return parseFloat(this.catalogProduct?.PRICE);
        },
        productPricePrint: function () {
            return (typeof BX?.Currency == 'object' && typeof BX?.Currency.currencyFormat == 'function' && this.productCurrency) ? BX?.Currency.currencyFormat(this.productPrice, this.productCurrency, true) : (this.productPrice + ' ' + this.productCurrency);
        },
        // sale price
        productDiscountPrice: function () {
            return parseFloat(this.catalogProduct?.DISCOUNT_PRICE);
        },
        productDiscountPricePrint: function () {
            return (typeof BX?.Currency?.currencyFormat == 'function' && this.productCurrency && this.productDiscountPrice > 0) ? BX?.Currency.currencyFormat(this.productDiscountPrice, this.productCurrency, true) : null;
        },
        getTitle: function () {
            return this.localize.PRODUCT_PRICE_NAME?.replace('#NAME#', this.catalogProduct?.NAME)?.replace('#PRICE#', this.productPricePrint);
        },
    },
    props: {
        'productId': Number,
    },
    template: `<div
        v-cloak
        :id="'sku-price-'+productCode"
        :title="getTitle"
        >
        <s v-if="productDiscountPrice > 0" v-html="productDiscountPricePrint"></s>
        <div v-html="productPricePrint" :class="{'product-item-price': !0, 'small':productDiscountPrice > 0}"></div>
    </div>`
});
